import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from "components/elements/loader/Loader";
import { showWarningMessage } from "reducers/application/applicationActions";

import OgaTable from "components/OgaTables/OgaTable";


class DisbursementHistoryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {
        return (
            <Modal
                {...this.props}
                animation={false}
                bsSize="large"
                aria-labelledby="contained-modal-title-sm"
                backdrop={"static"} >
                <Modal.Header>
                    <Modal.Title>Historial de la Solicitud</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.props.loading == false ?
                        <div>
                            <OgaTable
                                loading={this.props.loading}
                                headers={["Usuario", "Fecha", "Descripción", "Monto($)", "Estado"]}
                                properties={["executedByUser", "creationDate", "description", "amount", "disbursementStatusLabel"]}
                                pullRight={[3]}
                                pageCount={1}
                                onPageChange={this.onPageChange}
                                values={this.props.history}
                            />
                        </div>
                        :
                        <div className="w-100" style={{ height: "400px" }}>
                            <Loader show />
                        </div>
                    }
                </Modal.Body>

                <Modal.Footer>
                    <div>
                        <Button onClick={this.props.onHide} >Cerrar</Button> &nbsp;
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
const mapStateToProps = state => ({
    history: state.disbursementrequest.history
});
export default connect(
    mapStateToProps,
    { showWarningMessage }
)(DisbursementHistoryModal);



// WEBPACK FOOTER //
// ./src/components/DisbursementHistoryModal/DisbursementHistoryModal.jsx